import alert_mixin from '@/utils/mixins/alert_mixin';
import manual_verification_forms from './manual_verification_forms';
import manual_verification_linking from './manual_verification_linking';

export default {
  name: 'ManualVerification',
  mixins: [alert_mixin, manual_verification_forms, manual_verification_linking],
  created() {
    this.fetch_verification_forms();
  },
};